!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.InstagramLogin = t(require("react")) : e.InstagramLogin = t(e.react);
}(this, function (e) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 0);
  }([function (e, t, n) {
    e.exports = n(1);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    function c(e) {
      return window.location.search.substring(1).split("&").map(function (t) {
        var n = t.split("=");
        return n[0] === e ? n[1] : null;
      }).filter(function (e) {
        return !!e;
      })[0];
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = n(2),
        u = n.n(a),
        s = n(3),
        p = (n.n(s), function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }()),
        f = function (e) {
      function t(e) {
        r(this, t);
        var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return n.onBtnClick = n.onBtnClick.bind(n), n;
      }

      return i(t, e), p(t, [{
        key: "componentDidMount",
        value: function value() {
          if (this.props.implicitAuth) {
            var e = window.location.hash.match(/=(.*)/);
            e && this.props.onSuccess(e[1]);
          } else window.location.search.includes("code") ? this.props.onSuccess(c("code")) : window.location.search.includes("error") && this.props.onFailure({
            error: c("error"),
            error_reason: c("error_reason"),
            error_description: c("error_description")
          });
        }
      }, {
        key: "onBtnClick",
        value: function value() {
          var e = this.props,
              t = e.clientId,
              n = e.scope,
              r = this.props.redirectUri || window.location.href,
              o = this.props.implicitAuth ? "token" : "code";
          window.location.href = "https://api.instagram.com/oauth/authorize/?app_id=" + t + "&redirect_uri=" + r + "&scope=" + n + "&response_type=" + o;
        }
      }, {
        key: "render",
        value: function value() {
          var e = {
            display: "inline-block",
            background: "linear-gradient(#6559ca, #bc318f 30%, #e33f5f 50%, #f77638 70%, #fec66d 100%)",
            color: "#fff",
            width: 200,
            paddingTop: 10,
            paddingBottom: 10,
            borderRadius: 2,
            border: "1px solid transparent",
            fontSize: 16,
            fontWeight: "bold",
            fontFamily: '"proxima-nova", "Helvetica Neue", Arial, Helvetica, sans-serif'
          },
              t = this.props,
              n = t.cssClass,
              r = t.buttonText,
              o = t.children,
              i = t.tag,
              c = t.type;
          return u.a.createElement(i, {
            className: n,
            onClick: this.onBtnClick,
            style: n ? {} : e,
            type: c
          }, o || r);
        }
      }]), t;
    }(a.Component);

    f.defaultProps = {
      buttonText: "Login with Instagram",
      scope: "basic",
      tag: "button",
      type: "button",
      implicitAuth: !1
    }, t.default = f;
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "function" == typeof Symbol && Symbol.iterator, e.exports = n(4)();
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(6),
        i = n(7);

    e.exports = function () {
      function e(e, t, n, r, c, a) {
        a !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var o = function o() {};

    o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r, i, c, a, u) {
      if (o(t), !e) {
        var s;
        if (void 0 === t) s = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var p = [n, r, i, c, a, u],
              f = 0;
          s = new Error(t.replace(/%s/g, function () {
            return p[f++];
          })), s.name = "Invariant Violation";
        }
        throw s.framesToPop = 1, s;
      }
    }

    var o = function o(e) {};

    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }]);
});